import styled from "styled-components";

export const EventStatusText = styled.p<{ color: string }>`
  color: ${props => props.color};
`;
